import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { API_ENDPOINTS } from '@mysrc/app/api-endpoints';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services/base-http-req-resp.service';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonService } from '../../question/services/commonservice';
import { createSettings } from '../models/createSettings.model';
import { language } from '../models/language.model';
import { questionLanguageSetting } from '../models/questionLanguageSetting.model';
import { setting } from '../models/setting.model';

@Injectable()
export class SettingService extends BaseHttpReqRespService {
  myAppUrl: any;
  public headers!: Headers;
  SETTING_ENDPOINT = API_ENDPOINTS.SETTING;

  // public _getSettinglistUrl: string = 'Setting/GetSettingList/';
  // public _saveSettingUrl: string = 'Setting/SaveSetting/';
  // public _getEditSettingUrl: string = 'Setting/EditSetting/';
  // public _deleteSettingUrl: string = 'Setting/DeleteSetting/';

  // public _mapSectionToSettingUrl: string = 'Setting/MapSectionToSetting/';
  // public _unmapSectionToSettingUrl: string = 'Setting/UnMapSectionToSetting/';
  // public _arrangeSectionUrl: string = 'Setting/ArrangeSection/';
  // public _getMappedSectionListUrl: string = 'Setting/GetMappedSectionList/';
  // public _getUnmappedSectionListUrl: string = 'Setting/GetUnmappedSectionList/';

  // public _fetchOktaConfig: string = "/Home/GetOktaConfigDetails";
  // public _getTokenUrl: string = '/Question/GetAccessToken/';

  constructor(http: HttpClient
    , @Inject(OKTA_AUTH) private oauth: OktaAuth
    , private EncrDecr: EncrDecrService
    , private commonService: CommonService
    , @Inject('CONFIG_SETTINGS') configSettings: any) {
    super(http, oauth);
    const genSettings = configSettings[<any>'general'];
    this.baseUrl = genSettings[<any>'adminApiUrl'];
    this.apiKey = genSettings[<any>'apiKey'];
    this.myAppUrl = this.baseUrl;
  }

  //getAccessToken(): Observable<any> {
  //  return this.commonService.httpGet("", this.myAppUrl + this._getTokenUrl);
  //}

  getsettinglist(workspaceId: string): Observable<setting[]> {
    //let rawWorkspaceId = localStorage.getItem('workspaceId');
    //let workspaceId = rawWorkspaceId ? this.EncrDecr.get(rawWorkspaceId) : '0';
    return this.commonService.httpGet(
      "", `${this.myAppUrl}/${this.SETTING_ENDPOINT.LIST}/${workspaceId}`
    );
  }

  onEditSetting(params: any): Observable<any> {
    let settingId = params.data.settingId; // or params.settingId
    return this.commonService.httpGet(
      '',
      this.myAppUrl + 'Setting/EditSetting/' + settingId
    );
  }

  saveSetting(settingForm: any): Observable<any> {
    const workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    const userId = this.EncrDecr.get(localStorage.getItem('userId') ?? '');
    const url = `${this.myAppUrl}/${this.SETTING_ENDPOINT.SAVE}/${userId}/${workspaceId}`;
    return this.http.post<any>(url, settingForm, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  deleteSetting(settingId: number, workspaceid: string): Observable<any> {
    const url = `${this.myAppUrl}/${this.SETTING_ENDPOINT.DELETE}`;
    const body = { settingId, workspaceid };
    return this.http.post<any>(url, body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  // Get section details
  //getSurveySectionDetails(sectionId: number): Observable<any> {
  //  const param = "sectionId=" + sectionId;
  //  const httpOptions = {
  //    headers: new HttpHeaders({
  //      'Content-Type': 'application/x-www-form-urlencoded',
  //    })
  //  };
  //  return this.commonService.httpPost(param, this.myAppUrl + 'SurveySection/EditSection/', httpOptions);
  //}

  // Get all languages
  getLanguageList(): Observable<language[]> {
    return this.http.get<language[]>("/Survey/GetLanguageList", {
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      }
    });
  }

  // Get all language settings for a section
  //getAllSurveySectionLanguageList(sectionId: number): Observable<questionLanguageSetting[]> {
  //  return this.http.post<questionLanguageSetting[]>("/Question/GetAllQuestionLanguageSettings", '', {
  //    headers: {
  //      'Cache-Control': 'no-cache',
  //      'Pragma': 'no-cache'
  //    }
  //  }).pipe(
  //    // Filter on the client side as in the component
  //    map(data => data.filter(x => x.entityId == sectionId))
  //  );
  //}

  // Save (add/update) section language settings
  //saveSurveySectionLanguageSettings(model: any): Observable<any> {
  //  const httpOptions = {
  //    headers: new HttpHeaders({
  //      'Content-Type': 'application/json',
  //    })
  //  };
  //  return this.http.post<any>(this.myAppUrl + 'Question/SaveQuestionOptionsLanguageSettings', model, httpOptions);
  //}

  // Delete a language mapping
  //deleteSurveySectionLanguageMapping(questionId: number, mappingId: number): Observable<any> {
  //  const params = `?questionId=${questionId}&mappingId=${mappingId}`;
  //  return this.commonService.httpGet("", this.myAppUrl + 'Question/DeleteQuestionOptionsLanguageDetails/' + params);
  //}

  getMappedSections(settingId: string): Observable<createSettings[]> {
    const url = this.myAppUrl + '/' + this.SETTING_ENDPOINT.MAPPED_SECTION_LIST + '?settingId=' + settingId;
    return this.commonService.httpGet("", url);
  }

  getUnMappedSections(settingId: string, workspaceId: string): Observable<createSettings[]> {
    // Concatenate the global endpoint with the query string
    const url = this.myAppUrl + '/' + this.SETTING_ENDPOINT.UN_MAPPED_SECTION_LIST + '?settingId=' + settingId + '&workSpaceid=' + workspaceId;
    // Pass the local variable to httpGet
    return this.commonService.httpGet("", url);
  }

  mapSection(settingId: string, sectionIds: string[]): Observable<any> {
    const concatenated = sectionIds.join(',');
    const body = { settingId, sectionMapIdList: concatenated };
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.post<any>(this.myAppUrl + '/' + this.SETTING_ENDPOINT.MAP_SECTION, body, httpOptions);
  }

  unMapSection(settingId: string, sectionIds: string[]): Observable<any> {
    const concatenated = sectionIds.join(',');
    const body = { settingId, sectionMapIdList: concatenated };
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.post<any>(this.myAppUrl + '/' + this.SETTING_ENDPOINT.UN_MAP_SECTION, body, httpOptions);
  }

  arrangeOrder(settingId: string, orderedSectionIdList: string): Observable<any> {
    const body = { settingId, orderedSectionList: orderedSectionIdList };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.post<any>(this.myAppUrl + '/' + this.SETTING_ENDPOINT.ARRANGE_SECTION, body, httpOptions);
  }

}
